/* Nasorama – naso-tilbod.js
   Behaviour for the own offer modules (replaces BOGOS.io, Essential Upsell, Pop Convert):
   - keeps the 3-for-2 progress on the product page in sync with the cart
   - "Legg til" buttons: add to cart and refresh Dawn's cart drawer / cart page
   - the "all products" dialog
   - the corner teaser (close = hidden for 7 days) and the copy button
   Vanilla JS, no dependencies. Uses Dawn's pubsub (subscribe/publish) when present. */
(function () {
  'use strict';
  var TEASER_KEY = 'naso_teaser_closed';
  var TEASER_DAYS = 7;
  var routes = window.routes || {};

  /* ---------- 3-for-2 progress (product page only; the cart re-renders itself) ---------- */
  function progressText(n) {
    if (n <= 0) return 'Legg tre produkter i handlekurven – den rimeligste blir gratis.';
    if (n === 1) return '1 av 3 – legg til to produkter til, så blir den rimeligste gratis.';
    if (n === 2) return '2 av 3 – bare ett produkt til, så blir den rimeligste gratis!';
    if (n >= 6) return '🎉 To produkter blir gratis i kassen!';
    return '🎉 Den rimeligste blir gratis i kassen! Legg til ' + (6 - n) + ' til for enda ett gratis produkt.';
  }
  function renderProgress(n) {
    var els = document.querySelectorAll('[data-naso-progress="live"]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var filled = n >= 3 ? 3 : n;
      el.classList.toggle('is-done', n >= 3);
      var dots = el.querySelectorAll('.naso-progress__dots span');
      for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-on', d < filled);
      var t = el.querySelector('[data-naso-progress-text]');
      if (t) t.textContent = progressText(n);
    }
  }
  var countTimer;
  function refreshCount() {
    if (!document.querySelector('[data-naso-progress="live"]')) return;
    clearTimeout(countTimer);
    countTimer = setTimeout(function () {
      fetch((routes.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { renderProgress(c.item_count || 0); })
        .catch(function () {});
    }, 150);
  }
  /* Cart page: our own section is not part of Dawn's re-render list, so fetch it again */
  function refreshSections() {
    var els = document.querySelectorAll('[data-naso-section]');
    for (var i = 0; i < els.length; i++) {
      (function (el) {
        var id = el.getAttribute('data-naso-section');
        fetch((routes.cart_url || '/cart') + '?section_id=' + encodeURIComponent(id))
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('[data-naso-section]');
            if (fresh) el.innerHTML = fresh.innerHTML;
          })
          .catch(function () {});
      })(els[i]);
    }
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { refreshCount(); refreshSections(); });
  }

  /* ---------- Add to cart ---------- */
  function addToCart(btn) {
    var id = parseInt(btn.getAttribute('data-naso-add'), 10);
    if (!id || btn.disabled) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.classList.add('is-loading');
    var drawer = document.querySelector('cart-drawer');
    var onCartPage = !!document.querySelector('cart-items');
    var sections = '';
    if (drawer && !onCartPage && typeof drawer.getSectionsToRender === 'function') {
      sections = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
    }
    fetch((routes.cart_add_url || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1, sections: sections, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.json.description || res.json.message || 'add failed');
        var dlg = btn.closest('dialog');
        if (dlg && dlg.open) dlg.close();
        if (onCartPage && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          // Dawn's cart page listens for this and re-renders the item list (our module included)
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'naso-tilbod', productVariantId: id, cartData: res.json });
        } else if (drawer && res.json.sections && typeof drawer.renderContents === 'function') {
          // Dawn's product form does this too: an empty-cart drawer hides its header and items
          drawer.classList.remove('is-empty');
          drawer.renderContents(res.json);
        } else {
          window.location.href = routes.cart_url || '/cart';
          return;
        }
        btn.textContent = 'Lagt til ✓';
        setTimeout(function () { btn.textContent = label; }, 1800);
        refreshCount();
      })
      .catch(function (err) {
        btn.textContent = 'Prøv igjen';
        setTimeout(function () { btn.textContent = label; }, 2500);
        if (window.console) console.warn('[naso-tilbod]', err);
      })
      .then(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  }

  /* ---------- Copy button ---------- */
  function copyCode(btn) {
    var code = btn.getAttribute('data-naso-copy');
    var label = btn.textContent;
    function done() {
      btn.textContent = 'Kopiert ✓';
      setTimeout(function () { btn.textContent = label; }, 2000);
    }
    function fallback() {
      var ta = document.createElement('textarea');
      ta.value = code;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); done(); } catch (e) {}
      document.body.removeChild(ta);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, fallback);
    } else {
      fallback();
    }
  }

  /* ---------- Dialog ---------- */
  function openDialog(id) {
    var d = document.getElementById(id);
    if (!d) return;
    if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
  }
  function closeDialog(d) {
    if (!d) return;
    if (typeof d.close === 'function') d.close(); else d.removeAttribute('open');
  }

  /* ---------- One delegated click handler (the cart drawer is re-rendered, so no per-element binding) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var add = t.closest('[data-naso-add]');
    if (add) { e.preventDefault(); addToCart(add); return; }
    var copy = t.closest('[data-naso-copy]');
    if (copy) { copyCode(copy); return; }
    var open = t.closest('[data-naso-open]');
    if (open) { openDialog(open.getAttribute('data-naso-open')); return; }
    var close = t.closest('[data-naso-close]');
    if (close) { closeDialog(close.closest('dialog')); return; }
    if (t.tagName === 'DIALOG' && t.classList.contains('naso-dialog')) closeDialog(t); // backdrop click
  });

  /* ---------- Corner teaser ---------- */
  function initTeaser() {
    var t = document.querySelector('[data-naso-teaser]');
    if (!t) return;
    try {
      var closed = parseInt(localStorage.getItem(TEASER_KEY) || '0', 10);
      if (closed && Date.now() - closed < TEASER_DAYS * 864e5) return;
    } catch (e) {}
    var toggle = t.querySelector('[data-naso-teaser-toggle]');
    var panel = t.querySelector('[data-naso-teaser-panel]');
    var close = t.querySelector('[data-naso-teaser-close]');
    if (!toggle || !panel) return;
    t.hidden = false;
    toggle.addEventListener('click', function () {
      var open = panel.hidden;
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      t.classList.toggle('is-open', open);
    });
    if (close) {
      close.addEventListener('click', function () {
        t.hidden = true;
        try { localStorage.setItem(TEASER_KEY, String(Date.now())); } catch (e) {}
      });
    }
    /* Keep the teaser above the sticky add-to-cart bar (and Shopify's preview bar) */
    var ticking = false;
    function place() {
      ticking = false;
      var bottom = 12;
      var sticky = document.querySelector('[data-naso-sticky]');
      var pbar = document.getElementById('PBarNextFrameWrapper');
      if (sticky && !sticky.hidden) bottom = Math.max(bottom, window.innerHeight - sticky.getBoundingClientRect().top + 8);
      else if (pbar) bottom = Math.max(bottom, window.innerHeight - pbar.getBoundingClientRect().top + 12);
      t.style.bottom = bottom + 'px';
    }
    function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(place); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    place();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTeaser);
  } else {
    initTeaser();
  }
})();
